<script>
  import { Input } from "sveltestrap";
  import {
    activeSpec,
    unlockedSpecs,
    currentSpec,
    directContext,
  } from "../../editor/storage.js";
  import { cancelDirectContext, clearHighlight } from "../../editor/direct.js";
  import { firstLevelMenus } from "../../editor/menuSchema.js";
  import TreeView from "../component/Treeview.svelte";
  import { SpecTrees } from "../../editor/tree.js";
  import { onMount } from "svelte";
  onMount(() => {
    if ($directContext?.from_tree) {
      clearHighlight();
    }
  });
</script>

<section class="second-level-menu">
  <h2>
    {firstLevelMenus["selection"]?.title || "Selection"}
  </h2>

  {#if $activeSpec == -1}
    <div class="dupo-menu-pane mb-2 warn-msg pt-2" style="margin-top: -0.5rem;">
      <div class="dupo-menu-pane-row">
        <p class="text-sm">Use with an active artboard!</p>
      </div>
    </div>
  {:else if $directContext === undefined || $directContext?.from_tree}
    <div class="dupo-menu-pane mb-2">
      <div class="dupo-menu-pane-row">
        <p class="text-sm">
          Double-click entities/elements to edit. <br /><i
            class="bi bi-pencil"
          />
          indicates editable elements.<br />
          <sup><i class="bi bi-lock-fill" alt="locked" /></sup> indicates element(s)
          locked for responsive alternatives.
        </p>
      </div>
    </div>
    <div class="dupo-menu-pane mb-2">
      <div class="dupo-menu-pane-row">
        <h3 class="h-sub">
          <i class="bi bi-diagram-3 me-1" />Artboard structure
        </h3>
      </div>
      <div class="dupo-menu-pane-row">
        <TreeView node={$SpecTrees[$currentSpec.uid]} level={0} view={true} />
      </div>
    </div>
  {:else if !$unlockedSpecs.includes($currentSpec.uid)}
    <div class="dupo-menu-pane mb-2 warn-msg pt-2" style="margin-top: -0.5rem;">
      <div class="dupo-menu-pane-row">
        <p class="text-sm">Unlock this artboard first!</p>
      </div>
    </div>
  {:else}
    <div class="dupo-menu-pane mb-2">
      <div class="dupo-menu-pane-row mb-1">
        <h3 class="h-sub">Selection</h3>
      </div>
      <div class="dupo-menu-pane-form-row">
        <Input
          type="text"
          name="prompt"
          id="prompt"
          autocomplete="off"
          class="custom-form-select"
          value={$directContext?.paths?.join("/")}
          readonly
        />
      </div>
    </div>
    <div class="pane-divider" />
    {#if $directContext?.cmd?.length >= 1}
      <div class="dupo-menu-pane mb-2">
        <div class="dupo-menu-pane-row mb-1">
          <h3 class="h-sub">Actions</h3>
        </div>
        {#each $directContext.cmd as cmd}
          <div class="dupo-menu-pane-form-row">
            <button class="menu-second-level" type="button" on:click={cmd.run()}
              >{#if cmd.icon}<i
                  class={`bi bi-${cmd.icon} me-1`}
                />{/if}{cmd.name}</button
            >
          </div>
        {/each}
      </div>
      <div class="pane-divider" />
    {/if}
    <div class="dupo-menu-pane mb-2">
      <div class="dupo-menu-pane-button-row">
        <button
          type="button"
          on:click={() => {
            cancelDirectContext();
          }}><i class="bi bi-x-circle me-1" /> Cancel</button
        >
      </div>
    </div>
  {/if}
</section>
